import { Box, HStack, Image,Icon, Text } from '@chakra-ui/react'
import React from 'react'
import {HiOutlineArrowNarrowRight} from 'react-icons/hi'

const Mail = () => {
  return (
    <>
        <Box w='full' h={['100%' ,'75vh','75vh','50vh']} p={['2rem',"3rem","3rem",'3rem']} display='flex' flexDirection={['column','row']} gap='12' justifyContent='center' alignItems='center'>
            <Box border='1px solid #E8E8E8' p='24px'  borderRadius='16px' w={['279px',"32vw","30vw",'25vw']} h={['218px','250px']} display='flex' flexDirection='column' justifyContent='space-evenly' bg='#FCFCFD'>
                <Image src='/mail 1.png' w='24px' h='24px' alt=''/>
                <Text fontWeight='500' fontFamily='Duplicate Sans' fontSize={['20px','1.35rem']}>Send Us A Mail</Text>
                <Text lineHeight={['20px','32px']} fontSize={['10px',".75rem",'.75rem','1rem']}>For general enquiries and feedback, send our 
support team an email; get prompt assistance.</Text>
                <HStack>
                    
                    <Text fontSize='14px' color='#246BFD'>Send Mail</Text>
                    <Icon as={HiOutlineArrowNarrowRight} color='#246BFD' />
                </HStack>
            </Box>
            <Box border='1px solid #E8E8E8' p='24px'  borderRadius='16px' w={['279px',"32vw","30vw",'25vw']} h={['218px','250px']} display='flex' flexDirection='column' justifyContent='space-evenly' bg='#FCFCFD'>
                <Image src='/mesg.png' w='24px' h='24px' alt=''/>
                <Text fontWeight='500' fontFamily='Duplicate Sans' fontSize={['20px','1.35rem']}>Support</Text>
                <Text lineHeight={['20px','32px']} fontSize={['10px',".75rem",'.75rem','1rem']}>Already a user or have questions? Find the 
answers you need here.</Text>
                <HStack>
                    
                    <Text fontSize='14px' color='#246BFD'>FAQs</Text>
                    <Icon as={HiOutlineArrowNarrowRight} color='#246BFD' />
                </HStack>
            </Box>
        </Box>
    </>
  )
}

export default Mail